import React, { useEffect, useState } from 'react';
import { getPublications } from '../api/strapiClient';

export default function Publications() {
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    getPublications()
      .then((res) => {
        if (!cancelled) setPublications(res.data || []);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Unknown error');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <main className="page">
      <section className="hero">
        <p className="hero__eyebrow">The outlets</p>
        <h1 className="hero__title">Publications</h1>
        <p className="hero__subtitle">
          The independent outlets whose reporting we pull into the wire.
        </p>
      </section>

      {error && (
        <div className="state-message state-message--error">
          Couldn't reach the newsroom. {error}
        </div>
      )}
      {!error && loading && <div className="state-message">Loading publications…</div>}
      {!error && !loading && !publications.length && (
        <div className="state-message">No publications on file yet.</div>
      )}

      {!error && !loading && publications.length > 0 && (
        <div className="journalist-list">
          {publications.map((publication) => {
            const { name, websiteUrl } = publication;
            return (
              <a
                key={publication.id}
                href={websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="journalist-list__item"
              >
                <span className="journalist-list__name">{name}</span>
              </a>
            );
          })}
        </div>
      )}
    </main>
  );
}
